import * as yup from 'yup';

export const PaymentOptionsSchema = () => {
  const schemaShape = {
    paymentOption: yup.string().required('Please select a payment option')
  };

  return yup.object(schemaShape);
};
